import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ShohintaniKbn = props => {
  return <Dropdown.Static kubunKey='shohin_tani_kbn' {...props} />
}
